export default __webpack_public_path__ + "static/media/apple-logo.0a333fcd.svg";